import { NavItem } from '@/classes/nav/NavItem'

export default class BreadcrumbsNavItem extends NavItem {
  constructor ({ label, routeName, routeParams, id }) {
    super({ label, routeName, routeParams })

    this.id = id
  }
}
